import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';
import { XIcon } from 'lucide-react';

import { badgeVariants } from '@/components/ui/badge';

type TagProps = {
  onRemove?: (e: React.MouseEvent<HTMLButtonElement>) => void;
} & ComponentProps<'div'> &
  VariantProps<typeof badgeVariants>;

export function Tag(tagProps: TagProps) {
  const { variant, border, size = 'sm', children, onRemove, onClick, className, ...props } = tagProps;

  const handleRemove = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove(e);
    }
  };

  return (
    <div tabIndex={onClick ? -1 : 0} data-slot="tag" data-removable={!!onRemove} onClick={onClick} className={cn(badgeVariants({ variant, border, size }), onRemove && 'pr-1', className)} {...props}>
      {children}
      {onRemove && (
        <button
          type="button"
          onClick={handleRemove}
          className={cn(
            'flex aspect-square h-full z-10 shrink-0 items-center justify-center rounded-full [&_svg]:pointer-events-none [&_svg]:size-3.5 [&_svg]:shrink-0 select-none',
            'cursor-pointer outline-focus-ring hover:backdrop-saturate-125 hover:backdrop-contrast-125 outline-0 focus-visible:outline-3 disabled:cursor-not-allowed disabled:pointer-events-none disabled:opacity-60'
          )}
        >
          <XIcon className={cn('text-muted-foreground')} />
        </button>
      )}
    </div>
  );
}
